import axios from "axios";
const AxiosObjwithOutJWT = axios.create({
  baseURL: process.env.REACT_APP_COACH_WEB_URL,
  responseType: "json"
});
const AxiosObjPlatformwithOutJWT = axios.create({
  baseURL: process.env.REACT_APP_COACH_WEB_URL_PLATFORM,
  responseType: "json"
});
export {AxiosObjwithOutJWT, AxiosObjPlatformwithOutJWT}
